import { render, staticRenderFns } from "./FormsNav.vue?vue&type=template&id=ce96883e"
import script from "./FormsNav.vue?vue&type=script&lang=js"
export * from "./FormsNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports